/**
 * 本文件由 web/tools/gen-api-client.mjs 从 openapi/openapi.yaml 生成，请勿手改。
 * 重新生成：cd web && pnpm gen:api        校验漂移：cd web && pnpm gen:api:check
 *
 * 共生成 38 个 schema 类型、18 个按 operationId 命名的接口函数。
 * 约定（docs/CONTRACT.md 第 2、5 章）：
 *   - 请求自动带 X-Client-Type（按端注入）、Authorization（登录态）、
 *     X-Trace-Id（调用方给了就透传）；
 *   - 统一信封 ok=true 返回 data，ok=false 抛 ApiError（code/status/trace_id/details）；
 *   - 401 AUTH_TOKEN_EXPIRED：onTokenExpired 刷新后重放一次，仍失败则原样抛出。
 */

/* eslint-disable */
// eslint 关掉自动生成段：生成物不是手写代码，规则噪声会淹没真实告警。

export interface Meta {
  /** 全链路追踪号，与响应头 X-Trace-Id 一致 */
  trace_id?: string;
  page?: number;
  page_size?: number;
  total?: number;
}

export interface HealthEnvelope {
  ok: boolean;
  data: Health;
  meta?: Meta;
}

export interface Health {
  status?: "up" | "degraded" | "down";
  version?: string;
  started_at?: string;
  uptime_seconds?: number;
}

export interface ReadyEnvelope {
  ok?: boolean;
  data?: Ready;
  meta?: Meta;
}

export interface Ready {
  status?: "ready" | "not_ready";
  checks?: DependencyCheck[];
}

export interface DependencyCheck {
  /** postgres / redis / object_storage */
  name?: string;
  status?: "up" | "down" | "skip";
  latency_ms?: number;
  detail?: string;
}

export interface ErrorEnvelope {
  ok: boolean;
  code: string;
  message: string;
  trace_id: string;
  details?: ErrorDetail[];
}

export interface ErrorDetail {
  field?: string;
  reason?: string;
}

export interface SecondFactorEnvelope {
  ok: boolean;
  code: string;
  message: string;
  trace_id: string;
  details?: ErrorDetail[];
  data?: LoginResult;
}

export interface ReadyErrorEnvelope {
  ok: boolean;
  code: string;
  message: string;
  trace_id: string;
  data?: Ready;
}

export interface OkEnvelope {
  ok?: boolean;
  data?: Record<string, unknown>;
  meta?: Meta;
}

export interface LoginRequest {
  /** 账号或手机号 */
  account: string;
  password: string;
}

export interface LoginEnvelope {
  ok?: boolean;
  data?: LoginResult;
  meta?: Meta;
}

export interface LoginResult {
  stage?: "authenticated" | "second_factor_required";
  /** 二次验证挑战号，仅 stage=second_factor_required 时返回 */
  challenge_id?: string;
  masked_phone?: string;
  /** 挑战或令牌有效期秒数 */
  expires_in?: number;
  tokens?: Tokens;
  user?: Identity;
}

export interface SmsSendRequest {
  /** 二次验证场景必填 */
  challenge_id?: string;
  /** 绑定手机场景使用 */
  phone?: string;
  scene?: "login_2fa" | "bind";
}

export interface SmsSendEnvelope {
  ok?: boolean;
  data?: SmsSendResult;
  meta?: Meta;
}

export interface SmsSendResult {
  expires_in?: number;
  cooldown?: number;
  /** 仅 sms.provider=mock 时返回，生产恒为空 */
  dev_code?: string;
}

export interface VerifyRequest {
  challenge_id: string;
  code: string;
}

export interface RefreshRequest {
  refresh_token: string;
}

export interface TokenEnvelope {
  ok?: boolean;
  data?: Tokens;
  meta?: Meta;
}

export interface Tokens {
  access_token?: string;
  refresh_token?: string;
  token_type?: "Bearer";
  expires_in?: number;
}

export interface MeEnvelope {
  ok?: boolean;
  data?: Identity;
  meta?: Meta;
}

export interface Identity {
  user_id?: string;
  account?: string;
  name?: string;
  masked_phone?: string;
  org_id?: string;
  campus_ids?: string[];
  roles?: Role[];
  permissions?: string[];
  data_scope?: "self" | "group" | "dept" | "campus" | "all" | "custom";
  client_type?: "teacher" | "admin" | "crm" | "miniapp";
  must_change_password?: boolean;
}

export interface ChangePasswordRequest {
  old_password: string;
  /** 至少 10 位，含大小写字母、数字与符号中的三类 */
  new_password: string;
}

export interface User {
  id?: string;
  account?: string;
  name?: string;
  masked_phone?: string;
  email?: string;
  org_id?: string;
  campus_id?: string;
  department?: string;
  job_title?: string;
  status?: "active" | "disabled";
  must_change_password?: boolean;
  role_ids?: string[];
  created_at?: string;
  updated_at?: string;
}

export interface UserEnvelope {
  ok?: boolean;
  data?: User;
  meta?: Meta;
}

export interface UserListEnvelope {
  ok?: boolean;
  data?: User[];
  meta?: Meta;
}

export interface CreateUserRequest {
  account: string;
  name: string;
  phone: string;
  email?: string;
  org_id?: string;
  campus_id?: string;
  department?: string;
  job_title?: string;
  role_ids: string[];
}

export interface Role {
  id?: string;
  code?: string;
  name?: string;
  description?: string;
  status?: "active" | "disabled";
  data_scope?: "self" | "group" | "dept" | "campus" | "all" | "custom";
  permissions?: string[];
  member_count?: number;
}

export interface RoleListEnvelope {
  ok?: boolean;
  data?: Role[];
  meta?: Meta;
}

export interface Permission {
  code?: string;
  name?: string;
  module?: string;
  kind?: "menu" | "action" | "data";
  description?: string;
}

export interface PermissionListEnvelope {
  ok?: boolean;
  data?: Permission[];
  meta?: Meta;
}

export interface Campus {
  id?: string;
  org_id?: string;
  name?: string;
  region?: string;
  status?: "active" | "disabled";
  address?: string;
  contact_phone?: string;
}

export interface CampusListEnvelope {
  ok?: boolean;
  data?: Campus[];
  meta?: Meta;
}

export interface DictItem {
  code?: string;
  label?: string;
  value?: string;
  sort?: number;
  status?: "active" | "disabled";
  is_system?: boolean;
}

export interface DictItemListEnvelope {
  ok?: boolean;
  data?: DictItem[];
  meta?: Meta;
}

export interface AuditLog {
  id?: string;
  actor_id?: string;
  actor_name?: string;
  action?: string;
  object_type?: string;
  object_id?: string;
  result?: "success" | "denied" | "failed";
  message?: string;
  /** 变更前摘要，敏感字段已脱敏 */
  before_digest?: string;
  after_digest?: string;
  trace_id?: string;
  created_at?: string;
}

export interface AuditLogListEnvelope {
  ok?: boolean;
  data?: AuditLog[];
  meta?: Meta;
}

export interface ListUsersQuery {
  page?: number;
  page_size?: number;
  /** 姓名 / 工号 / 账号模糊搜索 */
  keyword?: string;
  status?: "active" | "disabled";
  campus_id?: string;
}

export interface ListDictItemsQuery {
  include_disabled?: boolean;
}

export interface ListAuditLogsQuery {
  page?: number;
  page_size?: number;
  actor_id?: string;
  action?: string;
  from?: string;
  to?: string;
}

/** 调用方身份，对应请求头 X-Client-Type；四端由构建期常量注入。 */
export type ClientType = 'teacher' | 'admin' | 'crm' | 'miniapp';

/** query 允许的标量类型；undefined 表示不传该参数。 */
export type QueryValue = string | number | boolean | undefined;

/** 归一化后的 query 字典。 */
export type QueryParams = Record<string, QueryValue>;

/** HTTP 方法白名单，避免生成物里出现任意字符串。 */
export type HttpMethod = 'GET' | 'POST' | 'PUT' | 'PATCH' | 'DELETE';

/** 单次请求的可选项。 */
export interface RequestOptions {
  /** 调用方自带追踪号时透传为 X-Trace-Id，便于与后端日志对齐。 */
  traceId?: string;
  /** 置 true 时不带 Authorization（登录/刷新等免鉴权接口）。 */
  skipAuth?: boolean;
  /** 取消信号，页面卸载时中止请求用。 */
  signal?: AbortSignal;
}

/** 统一信封中的错误码载体：前端只按 code 分支，message 仅用于展示。 */
export class ApiError extends Error {
  /** 全局唯一错误码，如 RBAC_PERMISSION_DENIED。 */
  readonly code: string;
  /** HTTP 状态码；网络层失败时为 0。 */
  readonly status: number;
  /** 全链路追踪号，取响应头 X-Trace-Id 与响应体 trace_id 的较优值。 */
  readonly traceId: string;
  /** 字段级明细（VALIDATION_FAILED / SYS_NOT_READY 等会用到）。 */
  readonly details: ErrorDetail[];
  /** 原始响应体：2FA 挑战等附加信息可能藏在 401 响应的 data 里。 */
  readonly payload: unknown;

  constructor(init: {
    code: string;
    message: string;
    status: number;
    traceId: string;
    details: ErrorDetail[];
    payload: unknown;
  }) {
    super(init.message);
    this.name = 'ApiError';
    this.code = init.code;
    this.status = init.status;
    this.traceId = init.traceId;
    this.details = init.details;
    this.payload = init.payload;
  }
}

/** api-client 装配参数。 */
export interface ApiClientConfig {
  /** 后端基地址；dev 走 Vite 代理时留空字符串即可。 */
  baseUrl: string;
  /** 端标识，自动写入 X-Client-Type。 */
  clientType: ClientType;
  /** 取当前内存中的 access token；无则返回 null。 */
  getAccessToken: () => string | null;
  /**
   * access 过期时的刷新钩子：true 表示已换到新 token，requester 重放一次。
   * 只重放一次；刷新失败由调用方负责清会话并回登录页。
   */
  onTokenExpired?: () => Promise<boolean>;
  /** 任意 ApiError 的旁路通知（用于统一 Toast），不改变原有抛出行为。 */
  onError?: (error: ApiError) => void;
  /** 可注入的 fetch 实现（测试/Mock 用），默认全局 fetch。 */
  fetchImpl?: typeof fetch;
}

/** 一次调用计划的内部形态。 */
interface CallPlan {
  method: HttpMethod;
  path: string;
  pathParams?: Record<string, string>;
  query?: QueryParams;
  body?: unknown;
  options?: RequestOptions;
}

/**
 * @what 类型守卫：判断值是否是普通对象
 * @param {unknown} value 任意值
 * @return {boolean} 是否对象
 */
function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null && !Array.isArray(value);
}

/**
 * @what 把 query 对象转成稳定字典，剔除 undefined（避免拼出 ?a=undefined）
 * @param {object} source 任意 query 对象
 * @return {QueryParams} 归一化结果
 */
function toQuery(source: object): QueryParams {
  const out: QueryParams = {};
  for (const [key, value] of Object.entries(source)) {
    if (value === undefined) continue;
    if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') {
      out[key] = value;
    }
  }
  return out;
}

/**
 * @what 按后端契约把 HTTP 状态与错误体烘焙成 ApiError
 * @why 前端一律按 code 分支（docs/错误码.md 使用约定 1），message 只做展示，
 *      因此这里必须保证 code/status/trace_id 三者都拿到，缺一不可排障。
 * @param {number} status HTTP 状态码
 * @param {unknown} payload 解析后的响应体
 * @param {string} headerTraceId 响应头 X-Trace-Id
 * @return {ApiError} 错误对象
 */
function toApiError(status: number, payload: unknown, headerTraceId: string): ApiError {
  const body = isRecord(payload) ? payload : {};
  const bodyTraceId = typeof body.trace_id === 'string' ? body.trace_id : '';
  const traceId = headerTraceId || bodyTraceId;
  // 非信封响应（网关 HTML 等）在调用处兜底，这里只处理「信封缺 code」。
  const code = typeof body.code === 'string' ? body.code : 'SYS_INTERNAL_ERROR';
  const message =
    typeof body.message === 'string' ? body.message : `请求失败（HTTP ${status}）`;
  const details = Array.isArray(body.details)
    ? body.details.filter((item): item is ErrorDetail => isRecord(item))
    : [];
  return new ApiError({ code, message, status, traceId, details, payload });
}

/**
 * @what 生成 requester：拼 URL/请求头 → 解信封 → 401 过期刷新重放一次
 * @why 四件事必须收在一处：所有组件禁止直接发请求（规范 4.4）；
 *      X-Client-Type 由端注入；X-Trace-Id 有则透传；信封 ok=false 一律抛 ApiError。
 * @param {ApiClientConfig} config 装配参数
 * @return {<T>(plan: CallPlan) => Promise<T>} 请求函数
 */
function createRequester(config: ApiClientConfig): <T>(plan: CallPlan) => Promise<T> {
  /**
   * @what 构造最终 URL（path 模板替换 + query 序列化）
   * @param {CallPlan} plan 调用计划
   * @return {string} 完整 URL
   */
  const buildUrl = (plan: CallPlan): string => {
    let path = plan.path;
    for (const [key, value] of Object.entries(plan.pathParams ?? {})) {
      path = path.replace(`{${key}}`, encodeURIComponent(value));
    }
    const search = new URLSearchParams();
    for (const [key, value] of Object.entries(plan.query ?? {})) {
      if (value === undefined) continue;
      search.set(key, String(value));
    }
    const queryString = search.toString();
    return `${config.baseUrl}${path}${queryString ? `?${queryString}` : ''}`;
  };

  /**
   * @what 组装请求头：集中注入端标识、追踪号与鉴权
   * @param {CallPlan} plan 调用计划
   * @return {Record<string, string>} 请求头
   */
  const buildHeaders = (plan: CallPlan): Record<string, string> => {
    const headers: Record<string, string> = {
      Accept: 'application/json',
      'X-Client-Type': config.clientType,
    };
    if (plan.body !== undefined) headers['Content-Type'] = 'application/json';
    const traceId = plan.options?.traceId;
    if (traceId) headers['X-Trace-Id'] = traceId;
    if (!plan.options?.skipAuth) {
      const token = config.getAccessToken();
      if (token) headers.Authorization = `Bearer ${token}`;
    }
    return headers;
  };

  /**
   * @what 真正发一次请求并解信封
   * @param {CallPlan} plan 调用计划
   * @return {Promise<T>} data 部分
   * @throws {ApiError} 网络失败 / ok=false / 非信封响应
   */
  const send = async <T>(plan: CallPlan): Promise<T> => {
    const doFetch = config.fetchImpl ?? fetch;
    const signal = plan.options?.signal;
    const init: RequestInit = {
      method: plan.method,
      headers: buildHeaders(plan),
      ...(signal ? { signal } : {}),
    };
    if (plan.body !== undefined) init.body = JSON.stringify(plan.body);

    let response: Response;
    try {
      response = await doFetch(buildUrl(plan), init);
    } catch (cause) {
      throw new ApiError({
        code: 'SYS_DEPENDENCY_UNAVAILABLE',
        message: '网络不可达，请确认后端已启动',
        status: 0,
        traceId: '',
        details: [],
        payload: cause,
      });
    }

    const headerTraceId = response.headers.get('X-Trace-Id') ?? '';
    const text = await response.text();
    let payload: unknown = null;
    if (text) {
      try {
        payload = JSON.parse(text) as unknown;
      } catch {
        payload = null;
      }
    }

    if (isRecord(payload) && typeof payload.ok === 'boolean') {
      if (payload.ok) {
        return (payload.data ?? null) as T;
      }
      throw toApiError(response.status, payload, headerTraceId);
    }

    // 反向代理 502/504 常返回 HTML，按依赖不可用处理，避免前端显示 undefined
    throw new ApiError({
      code: response.status >= 500 ? 'SYS_DEPENDENCY_UNAVAILABLE' : 'SYS_INTERNAL_ERROR',
      message: `接口返回了非信封响应（HTTP ${response.status}）`,
      status: response.status,
      traceId: headerTraceId,
      details: [],
      payload,
    });
  };

  /**
   * @what 带刷新重放的请求入口
   * @param {CallPlan} plan 调用计划
   * @param {boolean} retried 是否已重放过（只重放一次，防刷新死循环）
   * @return {Promise<T>} data 部分
   * @throws {ApiError} 原样抛出业务错误
   */
  const execute = async <T>(plan: CallPlan, retried: boolean): Promise<T> => {
    try {
      return await send<T>(plan);
    } catch (error) {
      if (!(error instanceof ApiError)) throw error;
      const shouldRefresh =
        !retried &&
        error.code === 'AUTH_TOKEN_EXPIRED' &&
        !plan.options?.skipAuth &&
        Boolean(config.onTokenExpired);
      if (shouldRefresh && config.onTokenExpired) {
        const refreshed = await config.onTokenExpired();
        if (refreshed) return execute<T>(plan, true);
      }
      config.onError?.(error);
      throw error;
    }
  };

  return <T>(plan: CallPlan): Promise<T> => execute<T>(plan, false);
}


/** 各端 api-client 的公共接口：方法名即 OpenAPI 的 operationId。 */
export interface ApiClient {
  /** 浅层探活，进程活着即 200，不查依赖（GET /healthcheck） */
  healthcheck(options?: RequestOptions): Promise<Health>;
  /** 就绪探活，DB/Redis/对象存储全部可达才 200（GET /ready） */
  ready(options?: RequestOptions): Promise<Ready>;
  /** 存活探活，不可恢复内部状态返回 500（GET /live） */
  live(options?: RequestOptions): Promise<Health>;
  /** 账号密码登录，必要时进入短信二次验证挑战（POST /api/v1/auth/login） */
  login(body: LoginRequest, options?: RequestOptions): Promise<LoginResult>;
  /** 发送短信验证码（POST /api/v1/auth/sms/send） */
  sendSmsCode(body: SmsSendRequest, options?: RequestOptions): Promise<SmsSendResult>;
  /** 提交短信验证码换取令牌（POST /api/v1/auth/login/verify） */
  verifySecondFactor(body: VerifyRequest, options?: RequestOptions): Promise<LoginResult>;
  /** 刷新访问令牌（POST /api/v1/auth/refresh） */
  refreshToken(body: RefreshRequest, options?: RequestOptions): Promise<Tokens>;
  /** 退出登录并吊销令牌（POST /api/v1/auth/logout） */
  logout(options?: RequestOptions): Promise<Record<string, unknown>>;
  /** 当前用户、角色、权限与数据范围（GET /api/v1/auth/me） */
  getMe(options?: RequestOptions): Promise<Identity>;
  /** 修改本人密码（首次登录强制）（POST /api/v1/auth/password） */
  changePassword(
    body: ChangePasswordRequest,
    options?: RequestOptions,
  ): Promise<Record<string, unknown>>;
  /** 用户列表，按数据范围过滤（GET /api/v1/users） */
  listUsers(query?: ListUsersQuery, options?: RequestOptions): Promise<User[]>;
  /** 新建员工账号（POST /api/v1/users） */
  createUser(body: CreateUserRequest, options?: RequestOptions): Promise<User>;
  /** 用户详情（GET /api/v1/users/{id}） */
  getUser(id: string, options?: RequestOptions): Promise<User>;
  /** 权限组列表（GET /api/v1/roles） */
  listRoles(options?: RequestOptions): Promise<Role[]>;
  /** 权限点清单，用于前端菜单与按钮生成（GET /api/v1/permissions） */
  listPermissions(options?: RequestOptions): Promise<Permission[]>;
  /** 校区列表，按数据范围过滤（GET /api/v1/campuses） */
  listCampuses(options?: RequestOptions): Promise<Campus[]>;
  /** 字典项，停用项默认不返回（GET /api/v1/dicts/{code}/items） */
  listDictItems(
    code: string,
    query?: ListDictItemsQuery,
    options?: RequestOptions,
  ): Promise<DictItem[]>;
  /** 操作日志，只读，敏感字段脱敏（GET /api/v1/audit-logs） */
  listAuditLogs(query?: ListAuditLogsQuery, options?: RequestOptions): Promise<AuditLog[]>;
}

/**
 * @what 按端配置创建 api-client
 * @param {ApiClientConfig} config 端配置（基地址、端标识、取 token、刷新钩子）
 * @return {ApiClient} 可直接注入到 store/hook 的客户端
 */
export function createApiClient(config: ApiClientConfig): ApiClient {
  const request = createRequester(config);
  return {
    /** 浅层探活，进程活着即 200，不查依赖（GET /healthcheck） */
    healthcheck(options: RequestOptions = {}): Promise<Health> {
      return request<Health>({
        method: 'GET',
        path: '/healthcheck',
        options,
      });
    },

    /** 就绪探活，DB/Redis/对象存储全部可达才 200（GET /ready） */
    ready(options: RequestOptions = {}): Promise<Ready> {
      return request<Ready>({
        method: 'GET',
        path: '/ready',
        options,
      });
    },

    /** 存活探活，不可恢复内部状态返回 500（GET /live） */
    live(options: RequestOptions = {}): Promise<Health> {
      return request<Health>({
        method: 'GET',
        path: '/live',
        options,
      });
    },

    /** 账号密码登录，必要时进入短信二次验证挑战（POST /api/v1/auth/login） */
    login(body: LoginRequest, options: RequestOptions = {}): Promise<LoginResult> {
      return request<LoginResult>({
        method: 'POST',
        path: '/api/v1/auth/login',
        body,
        options,
      });
    },

    /** 发送短信验证码（POST /api/v1/auth/sms/send） */
    sendSmsCode(body: SmsSendRequest, options: RequestOptions = {}): Promise<SmsSendResult> {
      return request<SmsSendResult>({
        method: 'POST',
        path: '/api/v1/auth/sms/send',
        body,
        options,
      });
    },

    /** 提交短信验证码换取令牌（POST /api/v1/auth/login/verify） */
    verifySecondFactor(body: VerifyRequest, options: RequestOptions = {}): Promise<LoginResult> {
      return request<LoginResult>({
        method: 'POST',
        path: '/api/v1/auth/login/verify',
        body,
        options,
      });
    },

    /** 刷新访问令牌（POST /api/v1/auth/refresh） */
    refreshToken(body: RefreshRequest, options: RequestOptions = {}): Promise<Tokens> {
      return request<Tokens>({
        method: 'POST',
        path: '/api/v1/auth/refresh',
        body,
        options,
      });
    },

    /** 退出登录并吊销令牌（POST /api/v1/auth/logout） */
    logout(options: RequestOptions = {}): Promise<Record<string, unknown>> {
      return request<Record<string, unknown>>({
        method: 'POST',
        path: '/api/v1/auth/logout',
        options,
      });
    },

    /** 当前用户、角色、权限与数据范围（GET /api/v1/auth/me） */
    getMe(options: RequestOptions = {}): Promise<Identity> {
      return request<Identity>({
        method: 'GET',
        path: '/api/v1/auth/me',
        options,
      });
    },

    /** 修改本人密码（首次登录强制）（POST /api/v1/auth/password） */
    changePassword(
      body: ChangePasswordRequest,
      options: RequestOptions = {},
    ): Promise<Record<string, unknown>> {
      return request<Record<string, unknown>>({
        method: 'POST',
        path: '/api/v1/auth/password',
        body,
        options,
      });
    },

    /** 用户列表，按数据范围过滤（GET /api/v1/users） */
    listUsers(query: ListUsersQuery = {}, options: RequestOptions = {}): Promise<User[]> {
      return request<User[]>({
        method: 'GET',
        path: '/api/v1/users',
        query: toQuery(query),
        options,
      });
    },

    /** 新建员工账号（POST /api/v1/users） */
    createUser(body: CreateUserRequest, options: RequestOptions = {}): Promise<User> {
      return request<User>({
        method: 'POST',
        path: '/api/v1/users',
        body,
        options,
      });
    },

    /** 用户详情（GET /api/v1/users/{id}） */
    getUser(id: string, options: RequestOptions = {}): Promise<User> {
      return request<User>({
        method: 'GET',
        path: '/api/v1/users/{id}',
        pathParams: { id },
        options,
      });
    },

    /** 权限组列表（GET /api/v1/roles） */
    listRoles(options: RequestOptions = {}): Promise<Role[]> {
      return request<Role[]>({
        method: 'GET',
        path: '/api/v1/roles',
        options,
      });
    },

    /** 权限点清单，用于前端菜单与按钮生成（GET /api/v1/permissions） */
    listPermissions(options: RequestOptions = {}): Promise<Permission[]> {
      return request<Permission[]>({
        method: 'GET',
        path: '/api/v1/permissions',
        options,
      });
    },

    /** 校区列表，按数据范围过滤（GET /api/v1/campuses） */
    listCampuses(options: RequestOptions = {}): Promise<Campus[]> {
      return request<Campus[]>({
        method: 'GET',
        path: '/api/v1/campuses',
        options,
      });
    },

    /** 字典项，停用项默认不返回（GET /api/v1/dicts/{code}/items） */
    listDictItems(
      code: string,
      query: ListDictItemsQuery = {},
      options: RequestOptions = {},
    ): Promise<DictItem[]> {
      return request<DictItem[]>({
        method: 'GET',
        path: '/api/v1/dicts/{code}/items',
        pathParams: { code },
        query: toQuery(query),
        options,
      });
    },

    /** 操作日志，只读，敏感字段脱敏（GET /api/v1/audit-logs） */
    listAuditLogs(
      query: ListAuditLogsQuery = {},
      options: RequestOptions = {},
    ): Promise<AuditLog[]> {
      return request<AuditLog[]>({
        method: 'GET',
        path: '/api/v1/audit-logs',
        query: toQuery(query),
        options,
      });
    },
  };
}
